import { render, staticRenderFns } from "./delegateDialog.vue?vue&type=template&id=67b8a5b0&scoped=true"
import script from "./delegateDialog.vue?vue&type=script&lang=js"
export * from "./delegateDialog.vue?vue&type=script&lang=js"
import style0 from "./delegateDialog.vue?vue&type=style&index=0&id=67b8a5b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b8a5b0",
  null
  
)

export default component.exports